import { render, staticRenderFns } from "./alhaq_loader.vue?vue&type=template&id=3e6ec984&scoped=true&"
import script from "./alhaq_loader.vue?vue&type=script&lang=js&"
export * from "./alhaq_loader.vue?vue&type=script&lang=js&"
import style0 from "./alhaq_loader.vue?vue&type=style&index=0&id=3e6ec984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ec984",
  null
  
)

export default component.exports